import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const PackageAlert = ({ user }) => {
  const [c, setC] = useState(null);
  const [sent, setSent] = useState(false);
  useEffect(() => {
    api.get("/company").then((r) => setC(r.data)).catch(() => {});
    api.get("/company/ricarica").then((r) => setSent(r.data.pending)).catch(() => {});
  }, [user.company_id]);
  if (!c || !c.xml_quota || c.xml_used / c.xml_quota < 0.8) return null;
  const pct = Math.round((c.xml_used / c.xml_quota) * 100);
  const ordina = async () => { try { await api.post("/company/ricarica"); setSent(true); toast.success("Richiesta di ricarica inviata allo Studio Principale"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="package-alert" className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <span className="flex items-center gap-2"><AlertTriangle className="h-4 w-4 shrink-0" /><span><b>Pacchetto di fatturazione quasi finito:</b> usati {c.xml_used} documenti su {c.xml_quota} ({pct}%).</span></span>
      {user.tenant_role === "admin" && <Button size="sm" className="bg-amber-600 hover:bg-amber-700" disabled={sent} data-testid="package-order-button" onClick={ordina}>{sent ? "Richiesta inviata" : "Ordina ricarica"}</Button>}
    </div>
  );
};
